import React from 'react';
import cn from 'classnames';
import { Form, Input as InputAntd } from 'antd';
import { InputProps } from './types';
import './style.scss';

export const Input: React.FC<InputProps> = ({ className, name, label, rules, formItemProps, ...props }) => {
  return (
    <div className={cn('form-item_input', className)}>
      <Form.Item name={name} label={label} rules={rules} labelCol={{ span: 24 }} {...formItemProps}>
        <InputAntd {...props} />
      </Form.Item>
    </div>
  );
};
